<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'ui-popover-item',
  props: {
    event: {
      type: Object,
      required: true
    },
    form: {
      type: Object,
      default: null
    }
  },
  computed: {
    startTime () {
      const [hh, mm] = this.event.start.toLocaleTimeString().split(':');

      return `${hh}:${mm}`;
    },
    leftDays () {
      const timeDiff = (new Date(this.event.extendedProps.endReg)) - (new Date());
      const count = Math.round(timeDiff / (1000 * 60 * 60 * 24));
      const left = this.$root.num2str(count, this.$root.staticText.events.left);
      const days = this.$root.num2str(count, this.$root.staticText.events.days);
      
      if (count < 0) {
        return {
          phrase: this.$root.staticText.events.regEnd,
          isEndReg: true
        };
      }

      return {
        phrase: `${left} ${count} ${days}`,
        isEndReg: false
      };
    }
  }
}
</script>

<template>
  <div class="t-events-calendar-block__item">
    <div class="t-events-calendar-block__head">
      <div class="t-events-calendar-block__time t-subtitle">
        {{ startTime }}
      </div>
      <div class="t-events-calendar-block__list">
        <template v-for="vendor in event.extendedProps.vendors">
          <template v-if="vendor.img">
            <a
              v-if="vendor.link"
              v-link
              :href="vendor.link"
              class="t-events-calendar-block__list-item"
            >
              <img
                :src="vendor.img"
                :alt="vendor.name"
              />
            </a>
            <span v-else class="t-events-calendar-block__list-item">
              <img
                :src="vendor.img"
                :alt="vendor.name"
              >
            </span>
          </template>
        </template>
      </div>
      <div class="t-main-slider__mark t-events-calendar-block__mark">
        {{ event.extendedProps.mark }}
      </div>
    </div>
    <a
      v-link
      :href="event.extendedProps.link"
      class="t-events-calendar-block__title t-subtitle"
    >{{ event.title }}</a>
    <div class="t-events-calendar-block__row">
      <div class="t-events-list__bottom">
        {{ leftDays.phrase }}
      </div>
    </div>
  </div>
</template>


// WEBPACK FOOTER //
// src/templates/pages/events/components/popover/popover-item.vue